import React from 'react'
import Svg from '../Svg'

export default ({
  width = 20,
  height = 20,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    aria-label={ ariaLabel }
  >
    <path d="M512 158c-228.094 0-413 184.906-413 413s184.906 413 413 413 413-184.906 413-413-184.906-413-413-413zM512 902.875c-183.289 0-331.875-148.588-331.875-331.875 0-183.289 148.586-331.875 331.875-331.875 183.287 0 331.875 148.586 331.875 331.875 0 183.287-148.588 331.875-331.875 331.875zM901.754 304.739c14.787-25.862 23.246-55.812 23.246-87.739 0-97.755-79.245-177-177-177-56.988 0-107.677 26.937-140.050 68.766 121.579 25.106 226.051 96.978 293.804 195.968v0zM416.050 108.766c-32.371-41.829-83.062-68.766-140.050-68.766-97.755 0-177 79.245-177 177 0 31.927 8.459 61.877 23.246 87.739 67.76-98.99 172.227-170.862 293.804-195.968zM512 571v-236h-59v295h236v-59z"/>
  </Svg>
